import { eachNotional } from '../../../pages/OrderEntryForm/OrderEntryHelper';

export const addNewRowStatus = (items: any[], results: string[]) => {
  return items.map((item) => {
    if (results.includes(item.tradeId)) {
      return {
        ...item,
        isNewlyAdded: true,
      };
    }
    return item;
  });
};

export const getPreviousBasketsRowData = (basket) => {
  return (
    basket?.rollupItemDetails?.basketItems?.map((b) => {
      return {
        fund: b.fundId,
        tradeDate: b.tradeDate,
        ticker: b.bbgTickerExch,
        securityName: b.securityName,
        price: b.price,
        quantity: b.quantity,
        currency: b.inputCurrency,
        swapCurrency: b.swapCurrency,
        dividendRate: b.divRate,
        fxRate: b.fxRate,
        notional: eachNotional(b.price, b.quantity, b.fxRate),
        tradeType: b.tradeType,
        tradeAction: b.tradeAction,
        tradeSource: b.tradeSource,
        settlementDate: b.settlementDate,
      };
    }) || []
  );
};
